// extracted by mini-css-extract-plugin
export default {"allstories":"User_allstories__SBIkM","stories":"User_stories__hnkHv"};